import React from 'react';
import { Layout, Typography } from 'antd';
import Logo from '../../icons/logo';
import styles from './header.module.scss';
import { useAtom } from 'jotai';
import { careProviderConfiguration, languagesAtom } from 'store';
import LanguageDropdown from '../language_dropdown';

const { Header: AntdHeader } = Layout;
const { Title } = Typography;
interface HeaderProps {
  showBorder?: boolean;
  title?: string;
  background?: string;
  showLanguageDropdown?: boolean;
}

const Header: React.FC<HeaderProps> = ({
  showBorder = true,
  title,
  background,
  showLanguageDropdown = true,
}) => {
  const [careProviderStyles] = useAtom(careProviderConfiguration);
  const [languages] = useAtom(languagesAtom);

  return (
    <AntdHeader
      className={styles.header}
      style={{
        padding: '0 20px',
        background: careProviderStyles.colorBgHeader || background,
        borderBottom: showBorder ? '1px #d9d9d9 solid' : 'none',
      }}
      data-cy="header"
    >
      <div className={styles.logoTextContainer} style={{ justifyContent: 'flex-start' }}>
        <Logo size="small" />
        {title && (
          <Title style={{ margin: '0px 10px' }} level={4}>
            {title}
          </Title>
        )}
      </div>
      <div className={styles.rightControls}>
        {showLanguageDropdown && !!languages?.length && <LanguageDropdown />}
      </div>
    </AntdHeader>
  );
};

export default Header;
